import createReactComponent from '../createReactComponent';
export default createReactComponent('menu', 'Menu', [["path",{"d":"M4.5 6.5h15M4.5 12h15m-15 5.5h15","key":"svg-0"}]]);